module.exports = __webpack_public_path__ + "img/figure-16.e21b2419.png";